import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { DocumentService } from '../../../core/services/document.service';
import { environment } from '../../../../environments/environment';
import { NavigationEnd, Router } from '@angular/router';
import { langsSupported } from '../../../core/enums/languages';

@Injectable({ providedIn: 'root' })
export class TranslateService {
  get i18nPageName() {

    let pageName = this.router.url
      .split('/')
      .filter((path) => !langsSupported.some((lang) => lang == path))[1];
    // console.log('pageName', pageName);
    // console.log(
    //   'this.document.location.pathname',
    //   this.document?.location?.pathname,
    // );

    if (this.router.url == '/' || pageName == '' || !pageName) {
      pageName = 'home';
    } else if (
      pageName &&
      (pageName.startsWith('qr_') || pageName.startsWith('_'))
    ) {
      pageName = 'landing-post';
    } else if (pageName.includes('hosting')
    ) {
      pageName = "html-hosting";
    }

    return pageName;
  }
  private translations: { [key: string]: string } = {};
  onLangChange = new EventEmitter();
  lastLang?: string;
  private lastPage?: string;
  private undefinedTranslations = new Set();
  translationsIsLoaded = false;
  constructor(
    private http: HttpClient,
    private router: Router,

  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        setTimeout(() => {
          //     if (this.lastPage == this.i18nPageName || !this.lastLang) return;
          this.lastPage = this.i18nPageName;
          this.loadTranslations();
        }, 0);
      }
    });
  }

  async setLanguage(lang: string): Promise<void> {
    console.log('lang', lang);
    console.log('this.i18nPageName', this.i18nPageName);

    if (this.lastLang == lang) return;
    this.lastLang = lang;
    return

    this.lastPage = this.i18nPageName;
    await this.loadTranslations();
  }

  private async loadTranslations() {
    if (!this.lastPage || !this.lastLang) return;
    let page = this.lastPage;
    let lang = this.lastLang;
    try {

      const data = await this.loadTranslationFile();
      if (this.lastLang == lang && this.lastPage == page) {
        this.translations = data;
        this.translationsIsLoaded = true;
        setTimeout(() => {

          this.onLangChange.emit();
        }, 0);
      }
    } catch (error) {
      this.lastLang = undefined;
      this.lastPage = undefined;
    }
  }

  private loadTranslationFile() {
    return firstValueFrom(
      this.http.get<{ [key: string]: string }>(
        `${environment.back.i18n}${this.lastPage}/${this.lastLang}.json`,
      ),
    );
  }

  get(key: string, params?: { [key: string]: any }): string {
    let transValue = this.translations[key];


    if (transValue === undefined && !this.undefinedTranslations.has(key)) {
      this.undefinedTranslations.add(key);
      if (this.translationsIsLoaded) {
        this.translate(key)
      }
    }

    let template = transValue || key;
    if (params) {
      for (const [paramKey, value] of Object.entries(params)) {
        const pattern = new RegExp(`{{\\s*${paramKey}\\s*}}`, 'g');
        template = template.replace(pattern, value);
      }
    }
    return template;
  }

  async translate(key: string) {
    if (this.lastLang != 'en' || environment.production || !key) return;
    await firstValueFrom(
      this.http.post(
        `i18n/translate`,
        {
          key,
          keyLanguage: 'en',
          app: 'posty5',
          engine: 'chatGPT',
        },
        {
          params: {
            isSilent: true,
          },
        },
      ),
    );
    this.assignPage(key);
  }
  async assignPage(key: string) {
    if (this.lastLang != 'en' || environment.production || !key) return;
    await firstValueFrom(
      this.http.post(
        `i18n/assign-page`,
        {
          key,
          keyLanguage: 'en',
          pageName: this.i18nPageName,
          //  pageName: 'all',
        },
        {
          params: {
            isSilent: true,
          },
        },
      ),
    );
  }
}
